import { FC } from 'react'

import { Icon } from '@trustycars/genie-ui/icons'

import usePageClass from '$browser/usePageClass'
import useRouter from '$actions/useRouter'
import useReturnToTarget from '$actions/useReturnToTarget'

import Link from '$elements/Link'
import StatusMessage from '$elements/StatusMessage'

import { container, header, title, gobackLink, content } from './styles.css'

const pageName = 'InvalidAccess'

export const InvalidAccess: FC = () => {
  usePageClass({ name: pageName })

  const {
    queryParams: { message }
  } = useRouter()

  const to = useReturnToTarget('root')

  const msg = message || 'Access denied. Please contact your administrator.'

  return (
    <article className={container}>
      <header className={header}>
        <h2 className={title}>Access denied</h2>
      </header>

      <main className={content}>
        <StatusMessage kind="danger">{msg}</StatusMessage>

        <Link to={to} className={gobackLink}>
          <Icon namespace="Left" /> Go back
        </Link>
      </main>
    </article>
  )
}

export default InvalidAccess
